const machining_workshop_map = require("./json/MachiningWorkshop.json")
const rotor_workshop_map = require("./json/RotorWorkshop.json");
const packaging_workshop_map = require("./json/PackagingWorkshop.json");
const testing_center_map = require("./json/TestingCenter.json");

export {
    machining_workshop_map,
    rotor_workshop_map,
    packaging_workshop_map,
    testing_center_map
}

export function _getMapJson(workshop) {
    switch (workshop) {
        case 'Machining':
            return machining_workshop_map;
        case 'Packing':
            return packaging_workshop_map;
        case 'Rotor':
            return rotor_workshop_map;
        case 'Testing':
            return testing_center_map;
        default:
            return null;
    }
}

export function _generateCpOfGeoMap(temp) {
    if (temp.features) {
        for (let feature of temp.features) {
            if (feature.properties && feature.properties.cp) {
                continue;
            }
            if (feature.geometry && feature.geometry.coordinates) {
                let max_x, min_x, max_y, min_y;
                for (let co of feature.geometry.coordinates[0]) {
                    let x = co[0], y = co[1];
                    if (!max_x || x > max_x) {
                        max_x = x;
                    }
                    if (!min_x || x < min_x) {
                        min_x = x;
                    }
                    if (!max_y || y > max_y) {
                        max_y = y;
                    }
                    if (!min_y || y < min_y) {
                        min_y = y;
                    }
                }
                if (max_x && min_x && max_y && min_y) {
                    feature.properties.cp = [(max_x + min_x) / 2, (max_y + min_y) / 2];
                }
            }
        }
    }
    return temp;
}